import { Icon } from "../components/Icon";
import { routeHash } from "../lib/routing.mjs";
import { useStore } from "../app/useStore";

export function LanguagePicker() {
  const store = useStore();
  return (
    <section className="language-welcome">
      <p className="overline">A world of small discoveries</p>
      <h1>What will you<br />make room for?</h1>
      <p>Choose a language. Find your rhythm through study, listening, and stories.</p>
      <div className="language-options">
        {store.registry.map((l) => (
          <a key={l.id} className="language-card" href={routeHash(l.id)}>
            <span className="language-emblem" lang={l.id}>{l.nativeName}</span>
            <div><h2>{l.name}</h2><p>Study. Listen. Understand.</p></div>
            <span className="round-arrow"><Icon name="arrow" /></span>
          </a>
        ))}
      </div>
      <p className="small-note">Your progress stays with each language, on this device.</p>
    </section>
  );
}
